import { withStyles } from '../../../utils/utils';

import styles from './ProgressBar.module.scss';

const cn = withStyles(styles);

export type ProgressBarProps = {
  percentComplete?: number;
  /** `line`: a 2px dark rule (the Stepper's connector). `track`: an 8px blue bar on a grey rounded track. */
  variant?: 'line' | 'track';
  className?: string;
};

export default function ProgressBar({ percentComplete = 50, variant = 'line', className }: ProgressBarProps) {
  return (
    <div className={cn('container', `variant-${variant}`, className)}>
      <div className={cn('highlight')} style={{ width: `${percentComplete}%` }} />
    </div>
  );
}
